/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_SwInputs */

const en_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const es_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const de_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const zh_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const ar_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const fr_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const vi_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const sw_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const th_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const bs_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const ja_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const ko_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const pt_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const it_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const sv_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const nl_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const da_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const nb_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const fi_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const pl_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const ru_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const tr_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const hi_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const id_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const ms_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const cs_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const el_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const he_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const af_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

const hu_nav_language_sw = /** @type {(inputs: Nav_Language_SwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiswahili`)
};

/**
* | output |
* | --- |
* | "Kiswahili" |
*
* @param {Nav_Language_SwInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_sw = /** @type {((inputs?: Nav_Language_SwInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_SwInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_sw(inputs)
	if (locale === "de") return de_nav_language_sw(inputs)
	if (locale === "zh") return zh_nav_language_sw(inputs)
	if (locale === "ar") return ar_nav_language_sw(inputs)
	if (locale === "fr") return fr_nav_language_sw(inputs)
	if (locale === "vi") return vi_nav_language_sw(inputs)
	if (locale === "sw") return sw_nav_language_sw(inputs)
	if (locale === "th") return th_nav_language_sw(inputs)
	if (locale === "bs") return bs_nav_language_sw(inputs)
	if (locale === "ja") return ja_nav_language_sw(inputs)
	if (locale === "ko") return ko_nav_language_sw(inputs)
	if (locale === "pt") return pt_nav_language_sw(inputs)
	if (locale === "it") return it_nav_language_sw(inputs)
	if (locale === "sv") return sv_nav_language_sw(inputs)
	if (locale === "nl") return nl_nav_language_sw(inputs)
	if (locale === "da") return da_nav_language_sw(inputs)
	if (locale === "nb") return nb_nav_language_sw(inputs)
	if (locale === "fi") return fi_nav_language_sw(inputs)
	if (locale === "pl") return pl_nav_language_sw(inputs)
	if (locale === "ru") return ru_nav_language_sw(inputs)
	if (locale === "tr") return tr_nav_language_sw(inputs)
	if (locale === "hi") return hi_nav_language_sw(inputs)
	if (locale === "id") return id_nav_language_sw(inputs)
	if (locale === "ms") return ms_nav_language_sw(inputs)
	if (locale === "cs") return cs_nav_language_sw(inputs)
	if (locale === "el") return el_nav_language_sw(inputs)
	if (locale === "he") return he_nav_language_sw(inputs)
	if (locale === "af") return af_nav_language_sw(inputs)
	if (locale === "hu") return hu_nav_language_sw(inputs)
	return en_nav_language_sw(inputs)
});